import { MobileApp } from '../libs/proto/commUnity_pb';

export const communityAppType = MobileApp.CLUB4267;

export const desktopMode = 4;
export const desktopModeURL = '';
